var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 0.666656H2.33331C1.80288 0.666656 1.29417 0.87737 0.919099 1.25244C0.544027 1.62752 0.333313 2.13622 0.333313 2.66666V9.33332C0.333313 9.86376 0.544027 10.3725 0.919099 10.7475C1.29417 11.1226 1.80288 11.3333 2.33331 11.3333H11.6666C12.1971 11.3333 12.7058 11.1226 13.0809 10.7475C13.4559 10.3725 13.6666 9.86376 13.6666 9.33332V2.66666C13.6666 2.13622 13.4559 1.62752 13.0809 1.25244C12.7058 0.87737 12.1971 0.666656 11.6666 0.666656V0.666656ZM11.6666 1.99999L7.33331 4.97999C7.23197 5.0385 7.117 5.06931 6.99998 5.06931C6.88295 5.06931 6.76799 5.0385 6.66665 4.97999L2.33331 1.99999H11.6666Z",
    fill: "#4D4D4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.ab2ad2f46a6ce857e4710ae297c79c99.svg";
export { ForwardRef as ReactComponent };